module.exports = __webpack_public_path__ + "static/media/lash2.57881d8b.png";